<div class="row">
  <div class="col-md-12">
    <p class="text-center font-weight-bold sb-b p-1">Create a Custom Outcome</p>
  </div>
</div>

<app-custom-outcome-standalone-panel></app-custom-outcome-standalone-panel>
